// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--MA825THYltdMvPYr"};